
import React from 'react'

import {
  Box,
  Flex,
  Text,

  Button,
  VStack,

  Drawer,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { FiMenu, FiHome, FiSettings, FiUsers } from 'react-icons/fi';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { MdComputer, MdLibraryBooks, MdNewspaper, MdReceipt } from 'react-icons/md';
import { FaTshirt } from 'react-icons/fa';
import { useAuth } from "../Context/AdminAuthContext";
import { useNavigate } from "react-router-dom";
function AdminSidebar() {
      const { isOpen, onOpen, onClose } = useDisclosure();
    
        const navigate = useNavigate();
      const handleLogout = () => {
        localStorage.removeItem("loginCheck");
        localStorage.removeItem("token");
        localStorage.removeItem("uid");
        localStorage.removeItem("loginsetName");
        localStorage.removeItem("role");
        localStorage.removeItem("email");
        localStorage.removeItem("username");
        document.cookie = "username=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        navigate("/");
      };
  return (
    <div>
         <Flex h="100vh" bg="gray.100">
              {/* Sidebar */}
              <Box
                as="nav"
                bg="white"
                w={{ base: 'full', md: '250px' }}
                h="full"
                borderRightWidth="1px"
                display={{ base: isOpen ? 'block' : 'none', md: 'block' }}
              >
<div className="flex flex-col p-4 space-y-4 justify-start">
      <h2 className="text-lg font-bold">Admin Panel</h2>
      <Link
        to="/admin"
        className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 p-2 rounded-md"
      >
        <FiHome />
        <span>Dashboard</span>
      </Link>
      <Link
        to="/admincategory"
        className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 p-2 rounded-md"
      >
        <FiSettings />
        <span>Category</span>
      </Link>
      <Link
        to="/admincustomers"
        className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 p-2 rounded-md"
      >
<FiUsers />
        <span>Customers List</span>
      </Link>
      <Link
        to="/staffmanagment"
        className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 p-2 rounded-md"
      >
<FiUsers />
        <span>Staff Managment</span>
      </Link>
      <Link
        to="/adminproducts"
        className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 p-2 rounded-md"
      >
        {/* <FiSettings /> */}
        <MdLibraryBooks />
        <span>Books & E-Books </span>
      </Link>
      <Link
        to="/AdminJournalAndBounds"
        className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 p-2 rounded-md"
      >
        {/* <FiSettings /> */}
      <MdNewspaper />
        <span>Bounds & Journals </span>
      </Link>
     
      <Link
        to="/adminclothes"
        className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 p-2 rounded-md"
      >
         <FaTshirt />
        <span>Clothing & Accessories </span>
      </Link>
      <Link
        to="/adminsoftware"
        className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 p-2 rounded-md"
      >
        <MdComputer />
        <span>Softwares </span>
      </Link>
      <Link
        to="/create-invoice"
        className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 p-2 rounded-md"
      >
        {/* <FiSettings /> */}
        <MdReceipt />
        <span>Invoice</span>
      </Link>
    </div>


    <button className='btn mt-5 ml-5' onClick={handleLogout}>Logout</button>

              </Box>
      
              {/* Mobile Drawer */}
              <Drawer isOpen={isOpen} onClose={onClose} placement="left">
                <DrawerOverlay />
                <DrawerContent>
                  <Box
                    as="nav"
                    bg="white"
                    w="full"
                    h="full"
                    borderRightWidth="1px"
                    p={4}
                  >
                    <VStack align="stretch" spacing={4}>
                      <Text fontSize="lg" fontWeight="bold">
                        Admin Panel
                      </Text>
                      <Button as={Link} to="/admin" leftIcon={<FiHome />} variant="ghost">
                        Dashboard
                      </Button>
                      <Button as={Link} to="/admincategory" leftIcon={<FiUsers />} variant="ghost">
                       Category
                      </Button>
                      <Button as={Link} to="/adminproducts" leftIcon={<FiSettings />} variant="ghost">
                       Products
                      </Button>
                    </VStack>
                  </Box>
                </DrawerContent>
              </Drawer>
              </Flex>
    </div>
  )
}

export default AdminSidebar
